module.exports = __webpack_public_path__ + "static/media/favicon.72bc6d83.ico";